import http from './httpService'

/*** Get sky sources based on filters from local database ***/
export function getSkySources(filtered) {
  const endPoint = filtered ? '/filtered' : '/all'

  return http.get(`/skysources${endPoint}`)
}

/*** Search sky sources by name ***/
export function searchSkySources(name) {
  if (!name) return console.log('name is undefined')

  return http.get(`/skysources/search/${name}`)
}

/*** Find one sky source by name / hip / hd / i18n (not limited to catalogue tiers) ***/
export function getSkySourceByName(name) {
  return http.get(`/skysources/name/${encodeURIComponent(name)}`)
}

/*** Save a sky source in local database ***/
export function saveSkySource(skySource) {
  if (!skySource) return console.log('skySource is undefined')

  return http.post(`/skysources/new`, skySource)
}

/*** Update internal name / nickname of sky source, in local database ***/
export function updateSkySourceInternalName(name, internalName) {
  if (!name) return console.log('name is undefined')

  return http.put(`/skysources/internal-name/${encodeURIComponent(name)}`, { internalName })
}

/*** Toggle visibility of sky source, in local database ***/
export function toggleSkySourceVisibility(name, isVisible) {
  if (!name) return console.log('name is undefined')

  return http.put(`/skysources/checked/${name}/${isVisible}`)
}

/*** Delete sky source from local database ***/
export function deleteSkySource(starName) {
  if (!starName) return console.log('starName is undefined')
  return http.delete(`/skysources/${starName}`)
}
